module.exports = __webpack_public_path__ + "static/media/neosurf.422a004f.svg";